import React from 'react';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about-content">
          <article className="about-text">
            <h2>About iBUILD 2025</h2>
            <p>
              iBUILD is TechBlit's flagship event — a one-day gathering designed to reignite the founders' culture in our ecosystem. 
              It's a movement to empower visionary founders, builders, and investors across the region.
            </p>
            <p>
              At its core, iBUILD exists to create a thriving community of doers — people who are not just talking about innovation 
              but are actively building companies, products, and systems that drive impact.
            </p>
          </article>
          <div className="about-visual">
            <img 
              src="/builders-evolution-flyer.jpg"
              alt="iBUILD 2025 - The Builder's Evolution event flyer showing conference details for December 13th in Port Harcourt, Nigeria"
              className="about-image"
              loading="lazy"
              width="600"
              height="400"
            />
             
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;

